import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import { Modal } from 'antd'
import Spinner from '../../spinner/spinner';
import { getCurrentUserSuccessReports } from './queries/getCurrentUserSuccessReports';
import { deleteSuccessReport } from "./mutations/deleteSuccessReport";
import { SuccessReportInfoCard } from "./successReportCard";
import { MINIMUM_PUBLISHED_PHASE, MISSING_REPORT_TEXT, ROLE_TO_TITLE_ROLE_MAPPING } from "./constants"
import './list.css';

const SuccessReport = ({report, editLink, onClick}) => (
  <SuccessReportInfoCard {...{report, editLink, onClick}}>
    <div>
      <p className="success-report-card__card-title">
        {report.signature} { report.status }
      </p>
      <p className="success-report__title">
        {report.title}
      </p>
      <p className="success-report__text">
        {report.text || MISSING_REPORT_TEXT}
      </p>
    </div>
  </SuccessReportInfoCard>
);

class SuccessReportList extends Component {
  getReportStatus(published) {
    if (ROLE_TO_TITLE_ROLE_MAPPING[this.props.data.current_user.type]) {
      return `(${published ? 'PUBLISHED' : 'NOT PUBLISHED'})`;
    } else {
      return null;
    }
  }

  mutationParams(reportId) {
    return {
      variables: {
        input: { id: reportId }
      },
      refetchQueries: [{
        query: getCurrentUserSuccessReports,
        variables: { id: this.props.selectedChurch.id }
      }]
    }
  }

  decorateReport = (report) => {
    const signature = `${ROLE_TO_TITLE_ROLE_MAPPING[report.author.type]} ${report.author.name}`;
    const published = this.props.data.church.revival.phase === MINIMUM_PUBLISHED_PHASE && report.id > 0;
    const status = this.getReportStatus(published);
    const editable = this.props.data.current_user.id === report.author.id;
    const deletable = editable && report.id > 0;
    return { ...report, signature, status, published, editable, deletable };
  };

  deleteReport(reportId) {
    const {data} = this.props.mutate(this.mutationParams(reportId));
  }

  showDeletingModalWindow = (reportId) => {
    Modal.confirm({
      title: "Are you sure you want to delete this event report?",
      width: 510,
      onOk: () => { this.deleteReport(reportId) }
    });
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }
    const church = this.props.data.church;
    return (
      <div>
        { church.revival.successReports.edges.map(edge => edge.node).map((report, index) =>
          <SuccessReport
              onClick={() => { this.showDeletingModalWindow(report.id) }}
              report={this.decorateReport(report)}
              key={index}
              editLink={`${this.props.match.url}/edit`}
          />
        )}
      </div>
    )
  }
}

export default compose(
  graphql(getCurrentUserSuccessReports, {
    options: ({ selectedChurch }) => ({ variables: { id: selectedChurch.id } })
  }),
  graphql(deleteSuccessReport)
)(SuccessReportList)



// WEBPACK FOOTER //
// ./src/components/pages/successReports/list.js